import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import logo from "../../assets/img/logo.png";

import AccountService from "../../services/AccountService";
import LmsService from "../../services/LmsService";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";

import shuffle from "../../utils/shuffleArray";
import { ordenationLetter } from "../../utils/ordenation";

import Spinner from "../Spinner";
import Config from "../../config/config";
import { check } from "graphql-anywhere";

const lmsService = new LmsService();
const accountServices = new AccountService();

export default function Proof({
  proof_id,
  item_id,
  item_type,
  getAuthenticatedUserToken
}) {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (item_type === "course") {
      window.customData.curso.indice = 3;
    }
    window.customData.curso.etapa = "queremos-sua-opiniao";
    async function getAuthenticatedUserAndSetUrl() {
      try {
        setLoading(true);
        const userResponse = await accountServices.getAuthenticatedUser();

        if (item_id) {
          const response = await axios.get(
            `${Config.baseUrl}/api/v1/lms/endereco_pesquisa_nps`,
            {
              params: {
                item_id,
                item_type,
                token: String(userResponse.data.get_authenticated_user.token)
              }
            }
          );
          setUrl(response.data.Invitationlink);
        }
      } catch (error) {
        toast.error("Ocorreu um erro ao buscar ao buscar as informações!");
        addToDataLayerGTM({
          event: "erro",
          descricao: "erro ao buscar avaliação"
        });
      } finally {
        setLoading(false);
      }
    }

    getAuthenticatedUserAndSetUrl();
  }, []);

  return (
    <div className="proofContainer">
      <h1>Queremos sua opinião!</h1>
      {loading ? (
        <div className="loadingContainer">
          <Spinner />
        </div>
      ) : (
        <div className="proofContent">
          <div className="orientationProof">
            <img
              className="logo"
              src={logo}
              alt="Porto Educ"
              style={{ marginBottom: 50 }}
            />
            <h1>Como foi a sua experiência com a Porto Educ?</h1>

            <h3>Deixe aqui a sua opinião, é rapidinho!</h3>
            <a href={url} target="_blank">
              <button
                className="buttonProof buttonProofSuccess"
                disabled={!url}
              >
                Iniciar avaliação
              </button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Proof/Proof.jsx